import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Authorization } from "../../Context/Authorization";
import { AuthContext } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";

const thStyle = {
    padding: "10px 12px",
    fontSize: 12,
    fontWeight: 700,
    color: "#2D3748",
    background: "#F7FAFC",
    border: "1px solid #E2E8F0",
    textAlign: "left"
};

const tdStyle = {
    padding: "9px 12px",
    fontSize: 12,
    color: "#4A5568",
    border: "1px solid #E2E8F0"
};

const ViewBankBalance = () => {
    const { role } = useContext(AuthContext);

    const [data, setData] = useState([]);
    const [jfmcTypes, setJfmcTypes] = useState([]);
    const [activeJfmc, setActiveJfmc] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const Api = process.env.REACT_APP_API;
    const roleName = role?.toLowerCase();

    useEffect(() => {
        fetchJfmcTypes();
    }, []);

    useEffect(() => {
        if (activeJfmc?._id) {
            fetchData();
        }
    }, [activeJfmc]);

    const fetchJfmcTypes = async () => {
        try {
            setLoading(true);

            const res = await axios.get(
                `${Api}/api/jfmc-types`,
                Authorization()
            );

            const types = Array.isArray(res.data) ? res.data : [];

            setJfmcTypes(types);

            // Default JFMC type = VFC
            const vfcType = types.find(
                (type) =>
                    String(type?.jfmcTypeName || "")
                        .trim()
                        .toUpperCase() === "VFC"
            );

            if (vfcType) {
                setActiveJfmc(vfcType);
            } else if (types.length > 0) {
                // Fallback if VFC is not available
                setActiveJfmc(types[0]);
            }

        } catch (err) {
            console.error("Failed to fetch JFMC types:", err);
        } finally {
            setLoading(false);
        }
    };
    const fetchData = async () => {
        try {
            setLoading(true);

            const res = await axios.get(
                `${Api}/api/closing-balance/hierarchy`,
                {
                    ...Authorization(),
                    params: {
                        jfmcTypeId: activeJfmc?._id
                    }
                }
            );

            setData(res.data || []);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const getTitle = () => {
        if (roleName === "user" || roleName === "fro")
            return "VFC Wise Balance";

        if (roleName === "dfo")
            return "Range Wise Balance";

        if (roleName === "ccf")
            return "Division Wise Balance";

        return "Circle Wise Balance";
    };

    const handleView = (item) => {
        navigate("/dashboard/view-closing-balance", {
            state: {
                id: item._id,
                name: item.name,
                jfmcTypeId: activeJfmc?._id
            }
        });
    };

    return (
        <div
            className="card p-3"
            style={{ padding: 16, overflowX: "auto" }}
        >
            {/* JFMC Type Selector */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 16,
                    flexWrap: "wrap",
                    gap: 12
                }}
            >
                <h5 style={{ margin: 0 }}>
                    {getTitle()}{" "}
                    {activeJfmc && (
                        <span style={{ color: "#2E7D32" }}>
                            ({activeJfmc.jfmcTypeName})
                        </span>
                    )}{" "}
                    As on{" "}
                    {data.length > 0
                        ? new Date(data[0].closingDate).toLocaleDateString(
                            "en-GB",
                            {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                            }
                        )
                        : "N/A"}
                </h5>

                <select
                    value={activeJfmc?._id || ""}
                    onChange={(e) => {
                        const selected = jfmcTypes.find(
                            (x) => x._id === e.target.value
                        );
                        setActiveJfmc(selected);
                    }}
                    style={{
                        padding: "8px 12px",
                        borderRadius: 8,
                        border: "1px solid #CBD5E0",
                        minWidth: 220
                    }}
                >
                    {jfmcTypes.map((type) => (
                        <option key={type._id} value={type._id}>
                            {type.jfmcTypeName}
                        </option>
                    ))}
                </select>
            </div>

            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse"
                }}
            >
                <thead>
                    <tr>
                        <th style={thStyle}>#</th>
                        <th style={thStyle}>{getTitle()}</th>
                        <th style={thStyle}>Cash</th>
                        <th style={thStyle}>Bank</th>
                        <th style={thStyle}>Total</th>
                        <th style={thStyle}>Action</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td
                                colSpan="6"
                                style={{
                                    textAlign: "center",
                                    padding: 20
                                }}
                            >
                                Loading...
                            </td>
                        </tr>
                    ) : data.length === 0 ? (
                        <tr>
                            <td
                                colSpan="6"
                                style={{
                                    textAlign: "center",
                                    padding: 20
                                }}
                            >
                                No balance data found
                            </td>
                        </tr>
                    ) : (
                        data.map((item, index) => (
                            <tr key={item._id}>
                                <td style={tdStyle}>
                                    {index + 1}
                                </td>

                                <td style={tdStyle}>
                                    {item.name}
                                </td>

                                <td
                                    style={{
                                        ...tdStyle,
                                        fontWeight: 600,
                                        color: "#2D3748"
                                    }}
                                >
                                    ₹{item.totalCash.toLocaleString("en-IN")}
                                </td>

                                <td
                                    style={{
                                        ...tdStyle,
                                        fontWeight: 600,
                                        color: "#2D3748"
                                    }}
                                >
                                    ₹{item.totalBank.toLocaleString("en-IN")}
                                </td>

                                <td style={tdStyle}>
                                    ₹{item.total.toLocaleString("en-IN")}
                                </td>

                                <td style={tdStyle}>
                                    <div className="jfmc-switch">
                                        <button
                                            className="btn btn-success"
                                            onClick={() => handleView(item)}
                                        >
                                            View Details
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default ViewBankBalance;